export default __webpack_public_path__ + "static/media/pdf_icon.58dbe727.png";